export default __webpack_public_path__ + "static/media/template17.6cafac71.svg";